import Vue from "vue";
import vSelect from "vue-select";
import ChipsMultiselect from 'v-chips-multiselect'

Vue.component("v-select", vSelect);
// Vue.component("ChipsMultiselect", ChipsMultiselect);
Vue.use(ChipsMultiselect)

window.offerSearchComponent = null;
window.setVue = function(vuecomponent) {
    window.offerSearchComponent = vuecomponent;
}

if(document.getElementById('app')) {
    window.onlyForm = document.getElementById('app').dataset.onlyForm === 'true';
    window.changeUrl = document.getElementById('app').dataset.changeUrl !== 'false';
    window.showPromoted = document.getElementById('app').dataset.showPromoted === 'true';
    window.cityParam = document.getElementById('app').dataset.city;
    window.categoriesParam = document.getElementById('app').dataset.categories;
    window.namesTagsParam = document.getElementById('app').dataset.namesTags;
    window.checkMainCategory = document.getElementById('app').dataset.checkMainCategory;

    var offerLink = document.getElementById('app').dataset.offerLink;

var app = new Vue({
    el: '#app',
    data: {
        url: 'https://api.magentateam.pl',
        key: '7dfgf63-k12yrr-pg8m4s-ob88v5',
        // url: 'https://tm-api.asap.ninja',
        // url: 'https://api.local',
        // key: '8dfgf63-k12yrr-pg8m4s-ob88v5',
        // key: 'hru5o-jds6ew-pp8utd-afcg44',
        resultsPage: 'rezultat-wyszukiwania.html',
        cities: [],
        categories: [],
        titles_tags: [],
        list: [],
        promotedList: [],
        city: null,
        category: [],
        title_tag: [],
        isOpen: false,
        timeout: null,
        categorySeparator: ' - ',
        categoryOpen: false,
        onlyForm: false,
        doneRequests: 0,
        disableRequest: false,

        // pagination vars
        currentPage: 1,
        totalPages: 1,
        perPage: 12,
        indexOfLastOffer: 1,
        indexOfFirstOffer: 1,
        currentOffers: [],
        offerInit: false
    },
    created: function () {
        setVue(this);

        const setPerPage = (x) => {
            if (x.matches) {
                this.perPage = 3;
                this.currentPage = 1;
            } else {
                this.perPage = 8;
                this.currentPage = 1;
            }
            this.reloadPagination();
        }

        const mediaQuery = window.matchMedia("(max-width: 520px)");
        setPerPage(mediaQuery);
        mediaQuery.addListener(setPerPage);

    },
    mounted: function(){
        let that = this;

        if (window.showPromoted) {
            this.request("/api/list/" + this.key + "?promowane=1&categories=" +  encodeURIComponent(window.categoriesParam), function( data ) {
                that.promotedList = data;

                if (that.promotedList.length > 4) {
                    that.promotedList = that.promotedList.sort((a, b) => 0.5 - Math.random()).slice(0, 4);
                }
            });
        }

        this.request("/api/locations/" + this.key, function( data ) {
            that.cities = data;
            that.cities.unshift('Cała Polska');

            ++that.doneRequests;
            that.openListAfterLoadAllData();
        });
        this.request("/api/categories2/" + this.key, function( data ) {
            that.categories = data.map((element) => {
                element.categories = element.categories.map((cat) => {
                    cat.checked = false;
                    return cat;
                })
                return element;
            })

            ++that.doneRequests;
            that.openListAfterLoadAllData();

            //check main category
            if(window.checkMainCategory){
                setTimeout(() => {
                    window.checkMainCategory.split('||').forEach(id => {

                        that.categories.forEach(function (category) {
                            if(category.id == id){
                                document.getElementById(id).checked = true;
                                that.setOverCategory2(id, category.name);
                            }
                        });

                    });
                }, 0);
            }
        });
        this.request("/api/tags/" + this.key, function( data ) {
            let tags = [];
            data.forEach(function (el) {
                tags.push({id:el, name:el, slug:el.toLowerCase()});
            });
            that.titles_tags = that.titles_tags.concat(tags);

            ++that.doneRequests;
            that.openListAfterLoadAllData();
        });
        // this.request("/api/job-position/" + this.key, function( data ) {
        this.request("/api/titles/" + this.key, function( data ) {
            let titles = [];
            data.forEach(function (el) {
                titles.push({id:el, name:el, slug:el.toLowerCase()});
            });
            that.titles_tags = that.titles_tags.concat(titles);

            ++that.doneRequests;
            that.openListAfterLoadAllData();

            setTimeout(()=>that.offerInit = true,2000);
        });

        let input = document.querySelector('input[placeholder="Stanowisko"]');
        if(input && this.lang == 'en-EN'){
            input.placeholder = this.positionLabel;
        }
    },
    computed: {
        lang: function () {
            return document.getElementsByTagName('html')[0].getAttribute('lang');
        },
        searchLabel: function () {
            return this.lang == 'en-EN' ? 'Search' :'Szukaj';
        },
        categoriesLabel: function () {
            return this.lang == 'en-EN' ? 'Categories' :'Kategorie';
        },
        cityLabel: function () {
            return this.lang == 'en-EN' ? 'City' :'Miasto';
        },
        positionLabel: function () {
            return this.lang == 'en-EN' ? 'Position' :'Stanowisko';
        },
        cvLabel: function () {
            return this.lang == 'en-EN' ? 'Send CV' :'Prześlij CV';
        }
    },
    methods: {
        openListAfterLoadAllData: function () {
            if (this.doneRequests === 4) {
                document.getElementsByClassName('content')[0].style.display = 'block';

                setTimeout(() => {
                    // Detect url params
                    const queryString = window.location;

                    let location = null;
                    let titlesTags = null;
                    let categories = null;

                    if (queryString) {
                        let url = new URL(queryString),
                          params = new URLSearchParams(url.search);
                          location = params.get('location');
                          titlesTags = params.get('titles_tags');
                          categories = params.get('categories');
                        // search = params.get('s');
                    }
                    location = location ? location : window.cityParam;
                    titlesTags = titlesTags ? titlesTags : window.namesTagsParam;
                    categories = categories ? categories : window.categoriesParam;


                    if (location) {
                        this.setCity(location);
                    }

                    if (titlesTags) {
                        this.setTitleTag(titlesTags.split('||').map((el) => { return {id:el, name:el, slug:el.toLowerCase()}}));
                    }
                    if (categories) {
                        categories.split('||').forEach(element => {
                            let cat = element.split(this.categorySeparator);
                            if (cat.length === 2) {
                                this.setCategory2(null, null, cat[0], cat[1]);
                            }
                        })
                    }

                    // if (search) {
                    //     document.getElementById('search').value = search;
                    // }
                    if (!window.onlyForm) {
                        this.getList();
                    }
                });
            }
        },
        clickOutside: function(e) {
            let panel = document.getElementById('categories-list');
            let that = this;
            if (!panel.contains(e.target)) {
                document.getElementsByClassName('js-categorySelect')[0].classList.remove('opened');
                document.getElementById('categories-list').classList.remove('is-visible');
                document.getElementsByClassName('chips')[0].classList.remove('hide-chips');
                document.removeEventListener('click', that.clickOutside);
                this.categoryOpen = !this.categoryOpen;
            }
        },
        toggleList: function() {
            if ( document.getElementsByClassName('content-search')[0].classList.contains('is-visible') ) {
//                document.getElementsByClassName('js-close-results')[0].classList.add('is-down');
                //document.getElementsByClassName('js-close-results')[0].classList.remove('is-visible');
                this.closeBox();
            } else {
                //document.getElementsByClassName('js-close-results')[0].classList.remove('is-down');
                this.openBox();
            }
        },
        openBox: function () {
            document.getElementsByClassName('content-search')[0].classList.add('is-visible');
            this.isOpen = true;
        },
        closeBox: function () {
            document.getElementsByClassName('content-search')[0].classList.remove('is-visible');
            this.isOpen = false;
        },
        showPreloader: function() {
            document.getElementsByClassName('lds-ripple')[0].classList.add('is-visible');

            //document.getElementsByClassName('js-close-results')[0].classList.remove('is-visible');  // close version
        },
        hidePreloader: function() {
            document.getElementsByClassName('lds-ripple')[0].classList.remove('is-visible');
        },
        showList: function() {
            document.getElementsByClassName('list-with-results')[0].classList.remove('is-visible');
            // document.getElementsByClassName('list-without-results')[0].classList.remove('is-visible');
        },
        hideList: function() {
            document.getElementsByClassName('list-with-results')[0].classList.remove('is-visible');
            // document.getElementsByClassName('list-without-results')[0].classList.remove('is-visible');
        },
        // openCategories: function(categories) {
        //
        //     this.category = category;
        //     this.getList();
        // },
        setCity: function(city) {
            this.city = city;
            if (this.isOpen) {
                this.getList();
            }
        },
        setTitleTag: function(title_tag) {
            this.title_tag = title_tag;
            if (this.isOpen) {
                this.getList();
            }
        },
        // setCategory: function(category) {
        //     this.category = category;
        //     if (this.isOpen) {
        //         this.getList();
        //     }
        // },
        setCategory2: function(overId, id, overName, name) {
            if (!overId && !id) {
                let c = this.categories.find(element => element.name === overName);
                overId = c.id;
                id = c.categories.find(element => element.name === name).id;
                document.getElementById(id).checked = true;
            }

            const fullName = overName + this.categorySeparator + name;
            if (document.getElementById(id).checked) {
                if(!this.category.includes(fullName)) {
                    this.category.push(fullName);
                }
                this.getCategory(overId, id).checked = true;

                if (undefined === this.getOverCategory(overId).categories.find(element => !element.checked)) {
                    document.getElementById(overId).indeterminate = false;
                    document.getElementById(overId).checked = true;
                } else {
                    document.getElementById(overId).indeterminate = true;
                    document.getElementById(overId).checked = false;
                }
            } else if(this.category.includes(fullName)) {
                const index = this.category.findIndex(element => element === fullName);
                this.category.splice(index, 1);
                this.getCategory(overId, id).checked = false;

                if (undefined === this.getOverCategory(overId).categories.find(element => element.checked)) {
                    document.getElementById(overId).indeterminate = false;
                    document.getElementById(overId).checked = false;
                } else {
                    document.getElementById(overId).indeterminate = true;
                    document.getElementById(overId).checked = false;
                }
            }

            if (this.isOpen) {
                this.getList();
            }
        },
        setIndex: function(e) {
            let hi = document.getElementsByClassName('indexUp');

            if (!e.currentTarget.classList.contains('indexUp')) {
                if (hi.length > 0) {
                    for (let i = 0; i < hi.length; i++) {
                        hi[i].removeAttribute('style');
                        hi[i].classList.remove('indexUp');
                    }
                }

                e.currentTarget.style.zIndex = 10;
                e.currentTarget.classList.add('indexUp');
            }


        },
        setOverCategory2: function(overId, overName) {
            this.disableRequest = true;
            let overCategory = this.getOverCategory(overId);
            let that = this;
            if (document.getElementById(overId).checked) {
                overCategory.categories.forEach(function (el) {
                    document.getElementById(el.id).checked = true;
                    that.setCategory2(overId, el.id, overName, el.name);
                })
            } else {
                overCategory.categories.forEach(function (el) {
                    document.getElementById(el.id).checked = false;
                    that.setCategory2(overId, el.id, overName, el.name);
                })
            }
            this.disableRequest = false;
            this.getList();
        },
        clearCategory: function() {
            this.disableRequest = true;
            let that = this;
            this.categories.forEach(function (overCategory) {
                overCategory.categories.forEach(function (el) {
                    if (el.checked) {
                        document.getElementById(el.id).checked = false;
                        that.setCategory2(overCategory.id, el.id, overCategory.name, el.name);
                    }
                })
            })
            this.disableRequest = false;
            this.getList();
        },
        toggleCategory: function() {
            if (!document.getElementsByClassName('js-categorySelect')[0]) {
                if (this.categoryOpen) {
                    document.getElementById('categories-list').classList.remove('is-visible');
                    document.getElementsByClassName('chips')[0].classList.remove('hide-chips');
                } else {
                    document.getElementById('categories-list').classList.add('is-visible');
                    document.getElementsByClassName('chips')[0].classList.add('hide-chips');

                    let that = this;
                    setTimeout(function() {
                        document.addEventListener('click', that.clickOutside);
                    }, 10);
                }

                this.categoryOpen = !this.categoryOpen;
            }
        },
        // searchOnChange: function () {
        //     clearTimeout(this.timeout);
        //     this.timeout = setTimeout(this.getList, 300);
        // },
        // clearSearch: function () {
        //     document.getElementById('search').value = '';
        //     if ( document.getElementsByClassName('content-search')[0].classList.contains('is-visible') ) {
        //         document.getElementsByClassName('js-close-results')[0].classList.remove('is-visible');
        //         this.closeBox();
        //     } else {
        //         document.getElementsByClassName('js-close-results')[0].classList.remove('is-down');
        //         this.openBox();
        //     }
        // },
        getOverCategory: function (overId) {
            return this.categories.find(element => element.id === overId);
        },
        getCategory: function (overId, id) {
            return this.getOverCategory(overId).categories.find(element => element.id === id);
        },
        getList: function () {
            if (this.disableRequest) {
                return;
            }

            let city = this.city === 'Cała Polska' ? null : this.city;
            // let category = this.category === 'Wszystkie' ? null : this.category;
            // let search = document.getElementById('search').value;
            // search = search ? search : null;

            let url = '';

            // if (city || category || search) {
            if (city || this.category.length || this.title_tag.length) {
                url = '?';
                if (city) {
                    url += 'location=' + encodeURIComponent(city) + '&';
                }
                if (this.title_tag.length) {
                    url += 'titles_tags=' + encodeURIComponent(this.title_tag.map(element => element.name).join('||')) + '&';
                }
                if (this.category.length) {
                    url += 'categories=' + encodeURIComponent(this.category.join('||')) + '&';
                }
                // if (search) {
                //     url += 'search=' + search + '&';
                // }
            }

            if (window.onlyForm && window.changeUrl) {
                window.location.href = window.location.href + '/' + this.resultsPage + url;
            } else {
                if (window.changeUrl) {
                    try {
                        history.replaceState('', null, window.location.href.split('/').slice(0, 3).join('/') + '/' + this.resultsPage + url);
                    } catch (e) {
                    }
                }
                let that = this;
                this.request("/api/list/" + this.key + url, function (data) {
                    that.currentPage = 1;
                    that.setCurrentPage(that.currentPage);
                    that.list = data;
                    if (that.list.length > 0) {
                        document.getElementsByClassName('list-with-results')[0].classList.add('is-visible');
                        // document.getElementsByClassName('list-without-results')[0].classList.remove('is-visible');
                        //document.getElementsByClassName('js-close-results')[0].classList.add('is-visible');
                    } else {
                        document.getElementsByClassName('list-with-results')[0].classList.remove('is-visible');
                        // document.getElementsByClassName('list-without-results')[0].classList.add('is-visible');
                    }
                    that.reloadPagination();
                });
                this.openBox();
            }

            //window.showPromoted ? promotedCarousel() : false;
        },
        showPagination: function() {
            document.getElementsByClassName('o-pagination')[0].classList.add('is-visible');
        },
        hidePagination: function() {
            document.getElementsByClassName('o-pagination')[0].classList.remove('is-visible');
        },
        reloadPagination: function() {
            this.totalPages = Math.ceil(this.list.length / this.perPage);
            this.indexOfLastOffer = this.currentPage * this.perPage;
            this.indexOfFirstOffer = this.indexOfLastOffer - this.perPage;
            this.currentOffers = this.list.slice(this.indexOfFirstOffer, this.indexOfLastOffer);
            if (this.list.length > this.perPage) {
                this.showPagination();
            } else {
                this.hidePagination();
            }
        },
        setCurrentPage: function(page) {
            this.currentPage = page;
            this.reloadPagination();
        },
        nextPage: function() {
            if(this.currentPage < this.totalPages) {
                this.setCurrentPage(this.currentPage + 1);
                window.runScroll('.content-search',50);
            }
        },
        prevPage: function() {
            if(this.currentPage > 1) {
                this.setCurrentPage(this.currentPage - 1);
                window.runScroll('.content-search',50);
            }
        },
        request: function (url, callback) {
            var request = new XMLHttpRequest();
            var that = this;
            that.showPreloader();
            that.hideList();
            request.onreadystatechange = function() {
                if(request.readyState === 4 && request.status === 200) {
                    that.hidePreloader();
                } else {
                    that.showPreloader();
                }
            }

            request.open('GET', this.url + url, true);

            request.onload = function() {
                if (this.status >= 200 && this.status < 400) {
                    callback(JSON.parse(this.response))
                }
            };
            request.send();
        },
        offerLink: function (id) {
            return offerLink + '?id=' + id;
        }
    },
    // render () {
    //     return (
    //     <div class="content" style="display: none">
    //
    //         <div class="c-findplace__results c-findplace__results--promoted is-visible" style={window.showPromoted ? '' : 'display:none'}>
    //             <header class="o-header">
    //                 <h2>Wyróżnione oferty pracy</h2>
    //             </header>
    //
    //             <div class="o-items swiper-container js-promotedSwiper anim anim--up">
    //                 <div class="swiper-wrapper">
    //                     {this.promotedList.map(item => {
    //                         let cat = item.hasOwnProperty('Kategoria') ? item.Kategoria.split(this.categorySeparator) : [];
    //                         cat = cat.length === 2 ? cat[1] : '';
    //                         return (
    //                           <a href={item.urlWithLayout} target="_blank" class="o-item swiper-slide">
    //                               <p class="o-item__location">{item.location}</p>
    //                               <p class="o-item__category">{item.title}</p>
    //                               <p class="o-item__title">{cat}</p>
    //                           </a>
    //                         )
    //                     })}
    //                 </div>
    //                 <div class="swiper-pagination dashes"></div>
    //             </div>
    //         </div>
    //
    //         <header class="o-header o-header--findplace js-child" style={window.showPromoted ? '' : 'display:none'} id="findform">
    //             <h2>Znajdź miejsce dla siebie</h2>
    //         </header>
    //
    //         <div class="content--panel">
    //             <div class="form-row">
    //                 <div class="form-group" onClick={this.setIndex}>
    //                     <ChipsMultiselect value={this.title_tag} on-input={(e) => this.setTitleTag(e)} items={this.titles_tags}  sorting-property={'slug'}  name-property={'name'}/>
    //                 </div>
    //                 {/*<div class="form-group search-on-typing">*/}
    //                 {/*    <input type="text" onKeyup={this.searchOnChange} id="search" placeholder="Stanowisko" autocomplete="off" />*/}
    //                 {/*    <a onClick={this.clearSearch} class="icon-close"></a>*/}
    //                 {/*</div>*/}
    //                 <div class="form-group" onClick={this.setIndex}>
    //                     <v-select options={this.cities} value={this.city} placeholder="Miasto" on-input={(e) => this.setCity(e)}></v-select>
    //             </div>
    //             <div class="form-group categories">
    //                 <div class="button">Kategorie&nbsp;
    //                     {this.category.length ? <span>{this.category.length}</span> : ''}
    //                 </div>
    //                 <div class="icon-close reset" onClick={this.clearCategory}></div>
    //                 {this.categoryOpen ?
    //                 <div class="arrow opened js-categorySelect" onClick={this.toggleCategory}><svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation" class="vs__open-indicator"><path d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"></path></svg></div> :
    //                 <div class="arrow" onClick={this.toggleCategory}><svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation" class="vs__open-indicator"><path d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"></path></svg></div>}
    //
    //                 {/*<v-select options={this.categories} value={this.category} placeholder="Obszar" on-input={(e) => this.setCategory(e)}></v-select>*/}
    //         </div>
    //         <div class="form-group submit">
    //             <button onClick={this.getList} class="o-btn o-btn--medium o-btn--magenta">Szukaj</button>
    //             <div class="lds-ripple"><div class="holder"><div></div><div></div></div></div>
    //         </div>
    //     </div>
    //
    //     <div id="categories-list" class="c-findplace__categories">
    //         <div class="o-content">
    //         {this.categories.map(item => {
    //             return (
    //               <div class="o-category__group">
    //                   <input type="checkbox" id={item.id}  on-input={() => this.setOverCategory2(item.id, item.name)}/>
    //                   <label for={item.id}>
    //                      <i></i>
    //                      <span>{item.name}</span>
    //                   </label>
    //
    //                   {item.categories.map(item_category => {
    //                       return (
    //                         <div class="o-category__item">
    //                             <input type="checkbox" id={item_category.id} on-input={() => this.setCategory2(item.id, item_category.id, item.name, item_category.name)}/>
    //                             <label for={item_category.id}>
    //                                 <i></i>
    //                                 <span>{item_category.name}</span>
    //                             </label>
    //                         </div>
    //                       )
    //                   })}
    //
    //               </div>
    //             )
    //         })}
    //         </div>
    //     </div>
    // </div>
    //
    //
    //     <div class="content-search">
    //
    //
    //         <div class="c-findplace__results list-without-results">
    //             <p>Nie widzisz oferty dla siebie? Nic straconego.</p>
    //             <p>Wyślij nam swoje CV i&nbsp;daj nam znać, czym chcesz zajmować się w&nbsp;<span class="u-nowrap">T-Mobile</span>.</p>
    //             <p>
    //                 <a href={document.getElementById('offers-vars').dataset.emptyLink} target="_blank" class="o-btn o-btn--medium o-btn--magenta">Prześlij CV </a>
    //             </p>
    //             <p class="back">lub wróć na <a href="/">Stronę Główną</a></p>
    //         </div>
    //
    //         <div class="c-findplace__results is-visible list-with-results">
    //             {/*<i class="close-results icon-close js-close-results" onClick={this.toggleList}></i>*/}
    //
    //             <div class="o-items">
    //                 {this.currentOffers.map(item => {
    //                     let cat = item.hasOwnProperty('Kategoria') ? item.Kategoria.split(this.categorySeparator) : [];
    //                     cat = cat.length === 2 ? cat[1] : '';
    //                     return (
    //                 <a href={item.urlWithLayout} target="_blank" class="o-item">
    //                     <p class="o-item__location">{item.location}</p>
    //                     <p class="o-item__category">{item.title}</p>
    //                     <p class="o-item__title">{cat}</p>
    //                 </a>
    //                     )
    //                 })}
    //             </div>
    //
    //
    //             <div class="o-pagination">
    //                 <ul>
    //                     <li><a onClick={this.prevPage} class="o-btn o-btn--medium o-btn--magenta o-btn--arrow reverse-arrow"></a></li>
    //                     <li><span class="page">Strona</span> {this.currentPage} z {this.totalPages}</li>
    //                     <li><a onClick={this.nextPage} class="o-btn o-btn--medium o-btn--magenta o-btn--arrow"></a></li>
    //                 </ul>
    //             </div>
    //
    //             <div class="o-back">
    //                 <a href="https://magentateam.pl/" class="o-btn o-btn--medium o-btn--magenta ">Strona główna</a>
    //                 <a href="https://magentateam.pl/sprzedaz-i-obsluga-klienta.html" class="o-btn o-btn--medium o-btn--magenta re-filter">Contact Center/Sklep</a>
    //             </div>
    //
    //         {/*<div class="o-more">*/}
    //         {/*    <a href="#" class="o-btn o-btn--medium o-btn--gray">Zobacz więcej</a>*/}
    //         {/*</div>*/}
    //         </div>
    //     </div>
    // </div>
    //     )
    // }
})
}
